/**
 * Events which relate to resources.
 */
export default class ResourceEvent {
    /**
     * Name of the event.
     * - changed : the resource has been changed
     * @returns {}
     */
    get name() { return this._name; }
    /**
     * Name of the event.
     * - changed : the resource has been changed
     * @returns {}
     */
    set name(value) {
        this._name = value;
    }
    /**
     * uri of affected resource.
     * @returns {}
     */
    get uri() { return this._uri; }
    /**
     * uri of affected resource.
     * @returns {}
     */
    set uri(value) {
        this._uri = value;
    }
    constructor(name, uri) {
        this._name = name;
        this._uri = uri;
    }
}
